<div class="modal-header">
  <button class="close" ng-click="agenda.close()">&times;</button>
  <h4 class="modal-title">Agenda</h4>
</div>
<div class="modal-body" ng-show="agenda.loading">
  <p class="text-cinza text-center">
    <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
  </p>
</div>
<div class="modal-body" ng-show="!agenda.creating && !agenda.loading">
  <p class="text-center" ng-hide="agenda.dates.length">
    Nenhuma tarefa encontrada na data especificada.
  </p>
  <div class="agenda-wrapper" ng-show="agenda.dates.length">
    <div class="agenda-title-wrapper">
      <div class="agenda-day-heading" ng-repeat="date in agenda.dates">
        {{date.date | date:'dd/MM/yy'}}
        <button class="btn btn-info btn-xs" ng-click="agenda.createTask(date.date)">
          <i class="fa fa-plus-circle"></i>
          Tarefa
        </button>
      </div>
    </div>
    <div class="agenda-days-wrapper tarefas-historicos">
      <uib-accordion close-others="true" class="list-tarefas" id="list-task-history" ng-repeat="date in agenda.dates">
        <uib-accordion-group
             class="panel-default panel-{{task.status.color}} {{task.status.color}} {{task.status.descricao == 'andamento' ? 'striped' : ''}}"
             is-open="task.open" ng-repeat="task in date.tasks">
          <uib-accordion-heading>
            <div ng-click="agenda.openTask($event, task)">
              <i class="pull-left {{task.tipo.icon}} fa fa-2x" aria-hidden="true" ></i>
              <i class="pull-right fa fa-2x" ng-hide="task.loading" ng-class="{'fa-minus-circle': task.open, 'fa-plus-circle': !task.open}"></i>
              <span ng-show="task.loading">
                <i class="pull-right fa fa-2x fa-spinner fa-spin"></i>
              </span>
              <span>
                {{task.acao}}
              </span>
              <br>
              <small class="text-white" ng-repeat="gleba in task.glebas track by $index">
                <span ng-show="gleba.gleba">
                  <span ng-show="$index">,</span>{{gleba.gleba.descricao | capitalize}} ({{gleba.gleba.area_total | number:0}} ha)
                </span>
                <span ng-hide="gleba.gleba">
                  <span ng-show="$index">,</span>{{gleba.descricao | capitalize}} ({{gleba.area_total | number:0}} ha)
                </span>
              </small>
            </div>
          </uib-accordion-heading>

          <p class="text-white" ng-show="task.finalizado_em && task.status.descricao == 'finalizado'">
            <small>
              Finalizado em {{task.finalizado_em | date: 'dd/MM/yyyy \'às\' HH:mm:ss'}}
            </small>
          </p>
          <p class="text-white" ng-show="task.status.descricao == 'andamento'">
            <small>Em andamento...</small>
          </p>
          <strong> Período previsto: </strong>
          {{task.data_inicial | date:'dd/MM/yyyy'}}  até {{task.data_final | date:'dd/MM/yyyy'}}
          <p>
            <strong>Responsável: </strong>
            {{task.responsavel.nome_completo | capitalize}}
          </p>
          <p ng-if="task.observacoes">
            <strong>Comentário:</strong>
            {{task.observacoes}}
          </p>

          <p>
            <strong>Criado em </strong>
            {{task.created_at | date:'dd/MM/yyyy \'às\' HH:mm'}}
          </p>
        </uib-accordion-group>
      </uib-accordion>
    </div>
  </div>
</div>
<div class="modal-body" ng-show="agenda.creating && !agenda.loading">
  <h3>Nova tarefa</h3>
  <form name="taskForm" class="row agenda-form" ng-submit="agenda.saveNewTask(taskForm)">
    <div class="col-xs-4">
      <div class="form-group" ng-class="{'has-error': taskForm.glebas.$invalid}" ng-if="agenda.creating && !loading">
        <label for="glebas" class="control-label">Talhões</label>
        <ui-select multiple ng-model="agenda.creatingData.glebas" theme="bootstrap" id="glebas" name="glebas" required>
          <ui-select-match allow-clear="true" placeholder="Selecione os Talhões...">{{$item.descricao | humanize}} ({{$item.area_total | number:0}} ha)</ui-select-match>
          <ui-select-choices repeat="gleba in $root.currentPropriedade.glebas | orderBy: 'descricao' | filter: $select.search">
            <span ng-bind-html="gleba.descricao | humanize | highlight: $select.search"></span> ({{gleba.area_total | number:0}} ha)
          </ui-select-choices>
        </ui-select>
      </div>
    </div>
    <div class="col-xs-4">
      <div class="form-group" ng-class="{'has-error': taskForm.responsavel.$invalid}">
        <label for="responsavel" class="control-label">Responsável</label>
        <ui-select ng-model="agenda.creatingData.responsavel" theme="bootstrap" id="responsavel" name="responsavel" required>
          <ui-select-match allow-clear="true" placeholder="Responsável">{{$select.selected.nome_completo | capitalize}}</ui-select-match>
          <ui-select-choices repeat="responsavel in agenda.responsaveis | orderBy: 'nome_completo' | filter: $select.search">
            <span class="form-group" ng-bind-html="responsavel.nome_completo | capitalize | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
        <p class="help-block" ng-show="taskForm.responsavel.$dirty && taskForm.responsavel.$error.required">Informe o Responsável</p>
      </div>
    </div>
    <div class="col-xs-4">
      <div class="form-group margin-data-inicial" ng-class="{'has-error': taskForm.dataTarefa.$invalid}">
        <label for="dataTarefa" class="control-label">Data da tarefa</label>
        <div class="input-group">
          <input type="text" class="form-control" readonly datepicker-options="agenda.datePickerOptions" placeholder="Data da tarefa"
            uib-datepicker-popup="{{agenda.popupData.format}}" ng-model="agenda.creatingData.dataInicial"
            is-open="agenda.popupData.openedData" show-button-bar="false"
            ng-change="agenda.creatingData.dataFinal = agenda.creatingData.dataInicial" id="dataTarefa" name="dataTarefa" required>
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="agenda.popupData.openedData = !agenda.popupData.openedData">
              <i class="glyphicon glyphicon-calendar"></i>
            </button>
          </span>
        </div>
        <p class="help-block" ng-show="taskForm.dataTarefa.$dirty && taskForm.dataTarefa.$error.required">Informe a data da tarefa</p>
      </div>
    </div>
    <div class="col-xs-12">
      <div class="form-group">
        <label for="observacao" class="control-label">Detalhamento da tarefa</label>
        <textarea class="form-control" ng-model="agenda.creatingData.observacao" id="observacao"
                  placeholder="Detalhamento da tarefa" name="observacao">
        </textarea>
      </div>
    </div>
    <div class="col-xs-12 text-right">
      <button type="button" class="btn btn-default" ng-click="agenda.creating = false">Cancelar</button>
      <button type="submit" class="btn btn-success">Salvar</button>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-white" ng-click="agenda.close()">
    Fechar
  </button>
</div>
